module.exports = __webpack_public_path__ + "img/Kira.fa672d5d.jpg";